import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Organization } from '../shared/models/organization.model';
import { CountAndResults, OrganizationSearch } from '../shared/types';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private http = inject(HttpClient);


  add(organization: Organization): Observable<void> {
    return this.http.post<void>('/api/organization', organization);
  }

  search(body: OrganizationSearch): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/organizations/search', body);
  }

  get(id: string): Observable<Organization> {
    return this.http.get<Organization>(`/api/organization/${id}`);
  }

  update(organization: Organization): Observable<void> {
    return this.http.put<void>(`/api/organization/${organization._id}`, organization);
  }

  delete(organization: Organization): Observable<void> {
    return this.http.delete<void>(`/api/organization/${organization._id}`);
  }

}
